module.exports = __webpack_public_path__ + "static/img/inr-banner-background.d933b47f.svg";